const dropzone = "_35sd1u23i59";
const placeholder = "_35spj3m4j8";
const dropzoneChildren = "_35sd3qlt8w";

export { dropzone, dropzoneChildren, placeholder };
import "./atom.target.style.linaria.module.css";
//# sourceMappingURL=atom.target.style.js.map
